import { action } from 'satcheljs/lib/legacy';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { isDragging } from './isDragging';

/**
 * Pauses a drag operation when the users moves out of a draggable while dragging
 * @param surfaceStore The surface store
 */
export let pauseDragOperation = action('pauseDragOperation')(function pauseDragOperation(
    surfaceStore: CalendarSurfaceStore
): void {
    let { dragDropState } = surfaceStore;
    if (!isDragging(surfaceStore.dragDropState)) {
        return;
    }

    dragDropState.droppableType = null;
});
